import React from "react";
import {
  faDiceD4,
  faDiceD6,
  faDiceD8,
  faDiceD10,
  faDiceD12,
  faDiceD20,
  IconDefinition,
} from "@fortawesome/pro-solid-svg-icons";
import ReactTooltip from "react-tooltip";
import { Die } from "../models/messages";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export interface Props {
  die: Die;
}

export default function DieIcon(props: Props) {
  const { die } = props;

  let icon: IconDefinition;
  switch (die) {
    case "d4":
      icon = faDiceD4;
      break;
    case "d6":
      icon = faDiceD6;
      break;
    case "d8":
      icon = faDiceD8;
      break;
    case "d10":
      icon = faDiceD10;
      break;
    case "d12":
      icon = faDiceD12;
      break;
    case "d20":
      icon = faDiceD20;
      break;
  }

  return (
    <>
      <FontAwesomeIcon icon={icon} className="text-light" size="lg" data-tip={die.toUpperCase()} data-place="bottom" />
      <ReactTooltip effect="solid" type="dark" />
    </>
  );
}
